var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedStat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 52,
    viewBox: "0 0 55 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.13844 18.825C9.13844 18.825 4.59811 12.25 8.7645 8.32222C12.9279 4.39444 19.8945 8.67778 19.8945 8.67778C19.8945 8.67778 21.6111 1 27.5 1C33.3889 1 35.1055 8.67778 35.1055 8.67778C35.1055 8.67778 42.075 4.39444 46.2384 8.32222C50.4048 12.25 45.8645 18.825 45.8645 18.825C45.8645 18.825 54 20.4444 54 26C54 31.5556 45.8645 33.175 45.8645 33.175C45.8645 33.175 50.4048 39.75 46.2384 43.6778C42.075 47.6056 35.1055 43.3222 35.1055 43.3222C35.1055 43.3222 33.3889 51 27.5 51C21.6111 51 19.8945 43.3222 19.8945 43.3222C19.8945 43.3222 12.9279 47.6056 8.7645 43.6778C4.59811 39.75 9.13844 33.175 9.13844 33.175C9.13844 33.175 1 31.5556 1 26C1 20.4444 9.13844 18.825 9.13844 18.825Z",
    stroke: "#EA5959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 15.9746V27.0857",
    stroke: "#EA5959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9757 31.2326C28.9757 31.9993 28.3161 32.6215 27.5035 32.6215C26.6908 32.6215 26.0312 31.9993 26.0312 31.2326C26.0312 30.466 26.6908 29.8438 27.5035 29.8438C28.3161 29.8438 28.9757 30.466 28.9757 31.2326Z",
    fill: "#EA5959"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedStat);
export default __webpack_public_path__ + "static/media/red-stat.a70d12f7.svg";
export { ForwardRef as ReactComponent };